import { connect } from 'react-redux'
import LoadingBar from './component'
import {
    getLocalizedText,
    getVersions,
    getSteam,
    getProgress,
    getClientText,
    getPatchNotes,
} from '../../selectors'
import { attributes, commands } from '../../imports'

function mapStateToProps(state) {
    const { launcherText } = getLocalizedText(state)
    const { launcherVersion, uiVersion } = getVersions(state)

    return {
        launcherText,
        launcherVersion,
        uiVersion,
        clientText: getClientText(state),
        patchNotes: attributes.patchNotes ? getPatchNotes(state) : null,
        patchNotesOnClick: () => commands.launcherOpenUrl(attributes.patchNotes),
        steamStartup: getSteam(state),
        progress: getProgress(state),
    }
}

export default connect(mapStateToProps)(LoadingBar)



// WEBPACK FOOTER //
// ./src/features/LoadingBar/components/LoadingBar/index.js